import { Pipe, PipeTransform } from '@angular/core';
import {LocalizedDatePipe} from "../localized-date.pipe";
import {MeasurementPrecisionTypes} from "@model";
import {MillisecondsToPrecisionPipe} from "./milliseconds-to-precision.pipe";

@Pipe({
  name: 'resultDateTime'
})
export class ResultDateTimePipe implements PipeTransform {
  constructor(private localizedDatePipe: LocalizedDatePipe, private millisecondsToPrecisionPipe: MillisecondsToPrecisionPipe) {}

  transform(dateTime?: string, milliseconds?: number, measurementPrecisionType?: MeasurementPrecisionTypes | undefined): string {
    if (!dateTime) {
      return '-';
    } else if (milliseconds === undefined || milliseconds === null || milliseconds === 0) {
      try {
        const date = new Date(dateTime.replace(' ', 'T'));
        return this.localizedDatePipe.transform(date, 'dd.MM.yyyy HH:mm:ss');
      } catch (e) {
        return `${dateTime}`;
      }
    }
    try {
      const date = new Date(dateTime.replace(' ', 'T'));
      let millisecondFromDate = date.getHours()* 3600000 + date.getMinutes() * 60000 + date.getSeconds() * 1000 + date.getMilliseconds();
      millisecondFromDate = millisecondFromDate + (milliseconds ?? 0);
      const time = this.millisecondsToPrecisionPipe.transform(millisecondFromDate, measurementPrecisionType!);
      const formattedDate = this.localizedDatePipe.transform(date, 'dd.MM.yyyy');
      return `${formattedDate} ${time}`;
    } catch (e) {
      return `${dateTime}${milliseconds ? '.' + milliseconds : ''}`;
    }
  }
}
